import { Color, Euler, IcosahedronGeometry, InstancedMesh, Matrix4, Quaternion, ShaderMaterial, Vector3 } from 'three';
import { ASTEROIDS } from '../universe/scenery';
import { SeededRandom } from '../core/SeededRandom';

export function makeRockField() {
  const geometry = new IcosahedronGeometry(1, 1), positions = geometry.getAttribute('position');
  for (let i = 0; i < positions.count; i++) {
    const p = new Vector3().fromBufferAttribute(positions, i);
    p.multiplyScalar(.9 + Math.sin(p.x * 17 + p.y * 11 + p.z * 23) * .14);
    positions.setXYZ(i, p.x, p.y, p.z);
  }
  geometry.computeVertexNormals();
  const material = new ShaderMaterial({
    vertexShader: /* glsl */`
      varying vec3 vNormal; varying vec3 vColor; varying vec3 vLocal;
      void main() {
        vLocal = position; vColor = instanceColor;
        vNormal = normalize(mat3(modelMatrix) * mat3(instanceMatrix) * normal);
        gl_Position = projectionMatrix * viewMatrix * modelMatrix * instanceMatrix * vec4(position, 1.);
      }`,
    fragmentShader: /* glsl */`
      varying vec3 vNormal; varying vec3 vColor; varying vec3 vLocal;
      void main() {
        float light = max(0., dot(normalize(vNormal), normalize(vec3(-.8,.45,.7))));
        float grain = .84 + .16 * sin(vLocal.x * 83. + vLocal.z * 53.) * sin(vLocal.y * 67.);
        gl_FragColor = vec4(vColor * (.045 + light * 1.25) * grain, 1.);
      }`,
  });
  const rocks = new InstancedMesh(geometry, material, ASTEROIDS.length), random = new SeededRandom(416);
  const matrix = new Matrix4(), rotation = new Quaternion();
  for (let i = 0; i < ASTEROIDS.length; i++) {
    const rock = ASTEROIDS[i]; rotation.setFromEuler(new Euler(...rock.rotation));
    matrix.compose(new Vector3(...rock.position), rotation, new Vector3().setScalar(rock.radius)); rocks.setMatrixAt(i, matrix);
    rocks.setColorAt(i, new Color(random.next() > .75 ? '#b8cad2' : '#8b8275').multiplyScalar(random.range(.6, 1.15)));
  }
  rocks.computeBoundingSphere(); rocks.name = 'Unmarked asteroid streams';
  return rocks;
}
